import { Container } from '@mui/material';

const Footer = () => <Container></Container>;

export default Footer;
